<miq-tag-editor-wrapper
  [tags]="tags"
  [canEdit]="canEdit"
  [filterUrl]="filterUrl"
  [entityId]="entityId"
  [addTagWhenEnter]="true"
  (tagsChanged)="onTagsChanged($event)"
></miq-tag-editor-wrapper>
